export default function isRichTextField(field?: FieldDto) {
    return field?.options?.render_variant === 'richText'
}
